import { DatePipe } from '@angular/common';
import { MatDateFormats } from '@angular/material/core';
import moment, {Moment} from "moment";

export const FORMAT: MatDateFormats = {
  parse: {
    dateInput: 'DDMMYYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'YYYY',
  },
};

export const TIMESTAMP_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const ISO8601_FORMAT = 'YYYY-MM-DDTHH:mm:ss';

export const dateFormat: string = 'dd/MM/yy';
export const hourFormat: string = 'HH:mm';
/**
* format date
* @param date string | Date
* @param format string
* @return string
*/
export function formatDate(date: string| Date, format: string): string {
  return new DatePipe('fr-FR').transform(date, format);
}

/**
 * generate Timestamp format to send to bff with selected date and time
 * @param date Moment
 * @param format string
 * @public
 */
export function generateTimestampFormatFromDate(date: Moment, format: string): string {
  return moment(date, 'YYYY-MM-DD').format(format).toString()
}

/**
 * generate Timestamp format to send to bff with selected date and time
 * @param date Moment
 * @param hour string
 * @private
 */
export function generateTimestampFormatFromDateAndHour(date: Moment, hour: string): string {
  const time = hour?.split(':');
  return moment(date, 'YYYY-MM-DD')?.set({
    hour: Number.parseInt(time[0]),
    minute: Number.parseInt(time[1]),
    second: 0,
    millisecond: 0
  })
    .format(TIMESTAMP_FORMAT).toString();
}

/**
 * autocomplete hour by :
 * @param dateValue
 * @private
 *
 * @return string
 */
export function completeHour(dateValue: string): string {
  if (dateValue?.length === 2) {
    return dateValue + ':';
  }
  return dateValue;
}

/**
 * Autocomplete hour: keeps only digits and ":"
 * @param hourValue
 */
export function autocompleteHour(hourValue: string): string {
    const value  = hourValue.replace(':', '').slice(0, 4);
    const hour = value?.slice(0, 2);
    const minute = value?.slice(2, 4);
    let completed = [hour,minute].filter(Boolean).join(':');
  if (value?.length ===2 && !completed.endsWith(':')) {
    completed += ':';
  }
  return completed;
  }

/**
 * Autocomplete date: keeps only digits and adds "/"
 * @param dateValue
 */
export function autocompleteDate(dateValue: string): string {
  const numbers = dateValue?.replace(/\D/g, '').slice(0,8);
  const day = numbers?.slice(0,2);
  const month = numbers?.slice(2,4);
  const year = numbers?.slice(4,8);
  let completed = [day,month,year].filter(Boolean).join('/');
  if((numbers?.length===2 || numbers?.length===4) && !completed.endsWith('/')) {
    completed += '/';
  }
  return completed;
}
